import PatientDataSummaryStatementNested from "./PatientDataSummaryStatementNested";
export default PatientDataSummaryStatementNested;
